import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingCities.css';

const SettingCities = () => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [editingCitie, setEditingCitie] = useState(null);
    const [newCitie, setNewCitie] = useState({
        stateId: "",
        city: "",
        Enero: "",
        Febrero: "",
        Marzo: "",
        Abril: "",
        Mayo: "",
        Junio: "",
        Julio: "",
        Agosto: "",
        Septiembre: "",
        Octubre: "",
        Noviembre: "",
        Diciembre: "",
        Promedio_Anual: ""
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchCities = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'Ciudades'));
            const citiesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            citiesData.sort((a, b) => a.city.localeCompare(b.city));
            setCities(citiesData);
            setFilteredCities(citiesData);
        } catch (error) {
            console.error("Error al cargar las ciudades: ", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchStates = async () => {
        const querySnapshot = await getDocs(collection(db, 'Estados'));
        const statesData = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        statesData.sort((a, b) => a.name.localeCompare(b.name));
        setStates(statesData);
    };

    useEffect(() => {
        fetchCities();
        fetchStates();
    }, []);

    useEffect(() => {
        const results = cities.filter(city => {
            const stateName = getStateName(city.stateId).toLowerCase();
            return city.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
                stateName.includes(searchTerm.toLowerCase());
        });
        setFilteredCities(results);
    }, [searchTerm, cities]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCitie({ ...newCitie, [name]: value });
    };

    const handleStateChange = (e) => {
        setNewCitie({ ...newCitie, stateId: e.target.value });
    };

    const handleEditCitie = (citie) => {
        setEditingCitie(citie);
        setNewCitie(citie);
    };

    const handleUpdateState = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas actualizar esta ciudad?",
            showCancelButton: true,
            confirmButtonText: "Sí, actualizar!",
            cancelButtonText: "No, cancelar!",
        });

        if (result.isConfirmed) {
            try {
                await updateDoc(doc(db, 'Ciudades', editingCitie.id), newCitie);
                Swal.fire("Actualizado", "La ciudad ha sido actualizado exitosamente.");
                setEditingCitie(null);
                setNewCitie({
                    stateId: "",
                    city: "",
                    Enero: "",
                    Febrero: "",
                    Marzo: "",
                    Abril: "",
                    Mayo: "",
                    Junio: "",
                    Julio: "",
                    Agosto: "",
                    Septiembre: "",
                    Octubre: "",
                    Noviembre: "",
                    Diciembre: "",
                    Promedio_Anual: ""
                });
                fetchCities();
            } catch (error) {
                console.error("Error al actualizar la ciudad en la base de datos", error);
                Swal.fire("Error", "No se pudo actualizar la ciudad.");
            }
        }
    };

    const handleDeleteCities = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás revertir esto!",
            showCancelButton: true,
            confirmButtonText: "Sí, bórralo!",
            cancelButtonText: "No, cancelar!",
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, 'Ciudades', id));
                Swal.fire("Borrado!", "La ciudad ha sido borrado.");
                fetchCities();
            } catch (error) {
                console.error("Error al borrar la ciudad en la base de datos", error);
                Swal.fire("Error", "No se pudo borrar la ciudad.");
            }
        }
    };

    const getStateName = (stateId) => {
        const state = states.find(state => state.id === stateId);
        return state ? state.name : 'Estado no encontrado';
    };

    return (
        <div className="setting-cities-container">
            <div className="title-actions">
                <h1 className="title">Gestión de Ciudades</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar un estado" onClick={() => navigate('/admin/ciudades')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por nombre del estado o ciudad"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="citie-list">
                    {filteredCities.length === 0 ? (
                        <p className="no-results">El estado o la ciudad que buscas no se encuentra registrado aún.</p>
                    ) : (
                        isMobile ? (
                            filteredCities.map(cities => (
                                <div key={cities.id} className="citie-card">
                                    {editingCitie && editingCitie.id === cities.id ? (
                                        <div className="edit-form">
                                            <div className="form-group">
                                                <label htmlFor="name">Ciudad</label>
                                                <input
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    placeholder="Nombre"
                                                    value={newCitie.city}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="stateId">Estado</label>
                                                <select
                                                    id="stateId"
                                                    name="stateId"
                                                    value={newCitie.stateId}
                                                    onChange={handleStateChange}
                                                >
                                                    <option value="">Selecciona un estado</option>
                                                    {states.map(state => (
                                                        <option key={state.id} value={state.id}>{state.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Enero">Enero</label>
                                                <input
                                                    type="text"
                                                    id="Enero"
                                                    name="Enero"
                                                    placeholder="Enero"
                                                    value={newCitie.Enero}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Febrero">Febrero</label>
                                                <input
                                                    type="text"
                                                    id="Febrero"
                                                    name="Febrero"
                                                    placeholder="Febrero"
                                                    value={newCitie.Febrero}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Marzo">Marzo</label>
                                                <input
                                                    type="text"
                                                    id="Marzo"
                                                    name="Marzo"
                                                    placeholder="Marzo"
                                                    value={newCitie.Marzo}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Abril">Abril</label>
                                                <input
                                                    type="text"
                                                    id="Abril"
                                                    name="Abril"
                                                    placeholder="Abril"
                                                    value={newCitie.Abril}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Mayo">Mayo</label>
                                                <input
                                                    type="text"
                                                    id="Mayo"
                                                    name="Mayo"
                                                    placeholder="Mayo"
                                                    value={newCitie.Mayo}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Junio">Junio</label>
                                                <input
                                                    type="text"
                                                    id="Junio"
                                                    name="Junio"
                                                    placeholder="Junio"
                                                    value={newCitie.Junio}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Julio">Julio</label>
                                                <input
                                                    type="text"
                                                    id="Julio"
                                                    name="Julio"
                                                    placeholder="Julio"
                                                    value={newCitie.Julio}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Agosto">Agosto</label>
                                                <input
                                                    type="text"
                                                    id="Agosto"
                                                    name="Agosto"
                                                    placeholder="Agosto"
                                                    value={newCitie.Agosto}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Septiembre">Septiembre</label>
                                                <input
                                                    type="text"
                                                    id="Septiembre"
                                                    name="Septiembre"
                                                    placeholder="Septiembre"
                                                    value={newCitie.Septiembre}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Octubre">Octubre</label>
                                                <input
                                                    type="text"
                                                    id="Octubre"
                                                    name="Octubre"
                                                    placeholder="Octubre"
                                                    value={newCitie.Octubre}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Noviembre">Noviembre</label>
                                                <input
                                                    type="text"
                                                    id="Noviembre"
                                                    name="Noviembre"
                                                    placeholder="Noviembre"
                                                    value={newCitie.Noviembre}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Diciembre">Diciembre</label>
                                                <input
                                                    type="text"
                                                    id="Diciembre"
                                                    name="Diciembre"
                                                    placeholder="Diciembre"
                                                    value={newCitie.Diciembre}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Promedio_Anual">Promedio Anual</label>
                                                <input
                                                    type="text"
                                                    id="Promedio_Anual"
                                                    name="Promedio_Anual"
                                                    placeholder="Promedio Anual"
                                                    value={newCitie.Promedio_Anual}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="btn-form-actions">
                                                <button className="btn-ac" title="Guardar" onClick={handleUpdateState}><FontAwesomeIcon icon={faAdd} /></button>
                                                <button className="btn-de" title="Cancelar" onClick={() => setEditingCitie(null)}><FontAwesomeIcon icon={faBan} /></button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="citie-info">
                                                <h3>{cities.city}</h3>
                                                <p><strong>Estado:</strong>{getStateName(cities.stateId)}</p>
                                                <p><strong>Enero:</strong> {cities.Enero}</p>
                                                <p><strong>Febrero:</strong> {cities.Febrero}</p>
                                                <p><strong>Marzo:</strong> {cities.Marzo}</p>
                                                <p><strong>Abril:</strong> {cities.Abril}</p>
                                                <p><strong>Mayo:</strong> {cities.Mayo}</p>
                                                <p><strong>Junio:</strong> {cities.Junio}</p>
                                                <p><strong>Julio:</strong> {cities.Julio}</p>
                                                <p><strong>Agosto:</strong> {cities.Agosto}</p>
                                                <p><strong>Septiembre:</strong> {cities.Septiembre}</p>
                                                <p><strong>Octubre:</strong> {cities.Octubre}</p>
                                                <p><strong>Noviembre:</strong> {cities.Noviembre}</p>
                                                <p><strong>Diciembre:</strong> {cities.Diciembre}</p>
                                                <p><strong>Promedio Anual:</strong> {cities.Promedio_Anual}</p>
                                            </div>
                                            <div className="btn-actions">
                                                <button className="btn-ed" title="Actualizar" onClick={() => handleEditCitie(cities)}><FontAwesomeIcon icon={faRotate} /></button>
                                                <button className="btn-de" title="Eliminar" onClick={() => handleDeleteCities(cities.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="citie-list">
                                <div className="citie-header">
                                    <span>Ciudad</span>
                                    <span>Estado</span>
                                    <span>Enero</span>
                                    <span>Febrero</span>
                                    <span>Marzo</span>
                                    <span>Abril</span>
                                    <span>Mayo</span>
                                    <span>Junio</span>
                                    <span>Julio</span>
                                    <span>Agosto</span>
                                    <span>Septiembre</span>
                                    <span>Octubre</span>
                                    <span>Noviembre</span>
                                    <span>Diciembre</span>
                                    <span>Promedio Anual</span>
                                    <span>Acciones</span>
                                </div>
                                <ul>
                                    {filteredCities.map(state => (
                                        <li key={state.id}>
                                            {editingCitie && editingCitie.id === state.id ? (
                                                <div className="edit-form-cities">
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        placeholder="Nombre"
                                                        className="input-name-cities"
                                                        value={newCitie.city}
                                                        onChange={handleInputChange}
                                                    />
                                                    <select
                                                        name="stateId"
                                                        value={newCitie.stateId}
                                                        onChange={handleStateChange}
                                                    >
                                                        <option value="">Selecciona un estado</option>
                                                        {states.map(state => (
                                                            <option key={state.id} value={state.id}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                    <input
                                                        type="text"
                                                        name="Enero"
                                                        placeholder="Enero"
                                                        value={newCitie.Enero}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Febrero"
                                                        placeholder="Febrero"
                                                        value={newCitie.Febrero}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Marzo"
                                                        placeholder="Marzo"
                                                        value={newCitie.Marzo}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Abril"
                                                        placeholder="Abril"
                                                        value={newCitie.Abril}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Mayo"
                                                        placeholder="Mayo"
                                                        value={newCitie.Mayo}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Junio"
                                                        placeholder="Junio"
                                                        value={newCitie.Junio}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Julio"
                                                        placeholder="Julio"
                                                        value={newCitie.Julio}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Agosto"
                                                        placeholder="Agosto"
                                                        value={newCitie.Agosto}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Septiembre"
                                                        placeholder="Septiembre"
                                                        value={newCitie.Septiembre}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Octubre"
                                                        placeholder="Octubre"
                                                        value={newCitie.Octubre}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Noviembre"
                                                        placeholder="Noviembre"
                                                        value={newCitie.Noviembre}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Diciembre"
                                                        placeholder="Diciembre"
                                                        value={newCitie.Diciembre}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Promedio_Anual"
                                                        placeholder="Promedio Anual"
                                                        value={newCitie.Promedio_Anual}
                                                        onChange={handleInputChange}
                                                    />
                                                    <div className="btn-actions">
                                                        <button className="btn-ac" title="Guardar" onClick={handleUpdateState}> <FontAwesomeIcon icon={faAdd} /></button>
                                                        <button className="btn-de" title="Cancelar" onClick={() => setEditingCitie(null)}><FontAwesomeIcon icon={faBan} /></button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span className="input-name">{state.city}</span>
                                                    <span className="input-state">{getStateName(state.stateId)}</span>
                                                    <span className="input-mes">{state.Enero}</span>
                                                    <span className="input-mes">{state.Febrero}</span>
                                                    <span className="input-mes">{state.Marzo}</span>
                                                    <span className="input-mes">{state.Abril}</span>
                                                    <span className="input-mes">{state.Mayo}</span>
                                                    <span className="input-mes">{state.Junio}</span>
                                                    <span className="input-mes">{state.Julio}</span>
                                                    <span className="input-mes">{state.Agosto}</span>
                                                    <span className="input-mes">{state.Septiembre}</span>
                                                    <span className="input-mes">{state.Octubre}</span>
                                                    <span className="input-mes">{state.Noviembre}</span>
                                                    <span className="input-mes">{state.Diciembre}</span>
                                                    <span className="input-mes">{state.Promedio_Anual}</span>
                                                    <button className="btn-ed" title="Actualizar" onClick={() => handleEditCitie(state)}> <FontAwesomeIcon icon={faRotate} /></button>
                                                    <button className="btn-de" title="Eliminar" onClick={() => handleDeleteCities(state.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default SettingCities;